import styled from "styled-components";

export const PromosBannerContainer = styled.div`
  position: relative;
  width: 100%;
  height: 312px;
  display: flex;
  align-items: center;
  background-color: var(--fd-colors-racing-background-default);

  @media screen and (min-width: 920px) {
    flex-direction: row;
  }

  @media only screen and (max-width: 919px) {
    flex-direction: column;
    width: 100%;
    height: auto;
    background: var(--fd-colors-background-promotional);
  }

  @media only screen and (max-width: 499px) {
    padding-bottom: 0%;
  }

  @media only screen and (min-device-width: 1025px) and (orientation: landscape) {
    width: 100%;
  }
`;

export const PromosBannerImageWrapper = styled.div`
  @media only screen and (max-width: 919px) {
    width: 100%;
  }
`;

export const PromosBannerImage = styled.img`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  object-fit: cover;
  background-color: var(--fd-colors-racing-background-default);

  @media only screen and (max-width: 919px) {
    display: none;
  }
`;

export const PromosMobileImage = styled.img`
  @media only screen and (max-width: 919px) {
    width: 100%;
    height: 180px;
    object-fit: cover;
    background-color: var(--fd-colors-racing-background-default);
  }

  @media only screen and (min-width: 920px) {
    display: none;
  }
`;
